/**
 * Welly — the working Labrador of docs/BRAND.md, as a field-guide plate mark.
 *
 * A calm head-in-profile silhouette, drawn in currentColor so it inherits
 * whatever brand token surrounds it (`text-primary`, `text-muted-foreground`)
 * and works in both the Reed Paper and dusk-marsh themes.
 *
 * Welly appears at moments, not as wallpaper: the loading state, the empty
 * retrieve, and the 404. Do not add other appearances.
 */
interface WellyMarkProps {
  /** Rendered width and height in pixels. */
  size?: number;
  className?: string;
  /** Accessible name. When omitted the mark is decorative (aria-hidden). */
  title?: string;
}

export function WellyMark({ size = 48, className, title }: WellyMarkProps) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: a <title> renders whenever one is provided; without one the mark is decorative and aria-hidden.
    <svg
      data-welly-mark
      viewBox="0 0 64 64"
      width={size}
      height={size}
      fill="currentColor"
      fillRule="evenodd"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      className={className}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M7 24.8
           C9.5 24.3 14 23.8 18.5 23.4
           C20.8 23.2 22.2 21.8 23.2 19.8
           C25.5 15.8 29 13.5 33.5 12.8
           C38 12.1 42 13.2 45 15.8
           C48 18.4 49.8 22.5 50.7 27.5
           C51.6 32.5 52 38.5 52 44
           L52 49.5
           C40 47 26 47 17.5 49.5
           C16.9 44.8 15.6 40 13.6 36.2
           C12.2 33.6 10 31.6 7.6 30.4
           C7.2 30.2 7 29.8 7 29.2
           Z
           M39.6 17.4
           C42.4 20.8 44.1 25.8 44.6 31.2
           C44.7 32.1 44 32.5 43.5 31.8
           C42.2 27 40.4 22.2 37.6 18.9
           C37 18.1 37.5 17.2 38.4 17.2
           C38.9 17.2 39.3 17.2 39.6 17.4
           Z
           M23.2 22.1
           C24.1 21.2 25.8 21.3 26.8 22.2
           C25.8 23.3 24 23.2 23.2 22.1
           Z"
      />
    </svg>
  );
}
